var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "annexesList" },
    [
      _c(
        "el-table",
        {
          ref: "annexesTable",
          staticStyle: { width: "100%" },
          attrs: {
            size: _vm.size,
            data: _vm.initTableData,
            border: "",
            height: _vm.height,
            stripe: "",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: { type: "selection", width: "55", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "accessUrl",
              label: _vm.$t("configMoudle.fileType"),
              align: "center",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-select",
                      {
                        staticClass: "file-type-select",
                        attrs: { size: "mini" },
                        on: {
                          change: function ($event) {
                            return _vm.handleFileTypeChange(row)
                          },
                        },
                        model: {
                          value: row.fjlx,
                          callback: function ($$v) {
                            _vm.$set(row, "fjlx", $$v)
                          },
                          expression: "row.fjlx",
                        },
                      },
                      _vm._l(_vm.fileDictList, function (option) {
                        return _c("el-option", {
                          key: option.value,
                          attrs: { value: option.value, label: option.label },
                        })
                      }),
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "realAttachName",
              label: _vm.$t("configMoudle.fileName"),
              align: "center",
              "min-width": "140",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "accessUrl",
              label: _vm.$t("configMoudle.thumbnail"),
              align: "center",
              width: "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.accessUrl
                      ? _c(
                          "el-image",
                          {
                            attrs: {
                              "preview-src-list": [row.accessUrl],
                              fit: "contain",
                              src: row.accessUrl,
                            },
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "error" }, slot: "error" },
                              [
                                _c("el-tag", { attrs: { size: "mini" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.checkFileType(row.realAttachName)
                                    )
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "createBy",
              label: _vm.$t("configMoudle.createBy"),
              width: "80",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "createTime",
              label: _vm.$t("userAdmin.createTime"),
              width: "140",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("LanguageSet.operation"),
              align: "center",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ $index, row }) {
                  return [
                    _c("i", {
                      staticClass: "el-icon-download",
                      staticStyle: { cursor: "pointer" },
                      on: {
                        click: function ($event) {
                          return _vm.handleEdit($index, row)
                        },
                      },
                    }),
                    _vm.showDel
                      ? _c("i", {
                          staticClass: "el-icon-delete-solid",
                          staticStyle: {
                            "margin-left": "5px",
                            cursor: "pointer",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleVirtualDel($index, row)
                            },
                          },
                        })
                      : _vm._e(),
                    _c("i", {
                      staticClass: "el-icon-view",
                      staticStyle: { "margin-left": "5px", cursor: "pointer" },
                      on: {
                        click: function ($event) {
                          return _vm.handleView($index, row)
                        },
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("configMoudle.tip"),
            visible: _vm.dialogVisible,
            "append-to-body": "",
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.$t("addTips.comfirmDelet")))]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("configMoudle.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.dialogVisibleok },
                },
                [_vm._v(_vm._s(_vm.$t("configMoudle.confirm")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }